<div class="mb-2">

  <mat-expansion-panel class="accordion accordion-maintenance accordion-default">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ formGroup.get('labelName')?.value || 'Nuevo elemento' }}
      </mat-panel-title>
      <button class="button button-danger button-xs mr-2" (click)="removeElement()">
        <i class="fas fa-trash-can" aria-hidden="true"></i>
      </button>
    </mat-expansion-panel-header>
    <div [formGroup]="formGroup" class="option-content">
      <div class="grid grid-cols-1 md:grid-cols-12 gap-4 mb-5">
        <div class="md:col-span-4">
          <label>Nombre de la etiqueta</label>
          <input class="input" formControlName="labelName" placeholder="Nombre de la etiqueta">
        </div>
        <div class="md:col-span-3">
          <label>Tipo de elemento</label>
          <mat-select class="select" formControlName="elementType">
            <mat-option *ngFor="let element of elements" [value]="element.id">{{ element.name }}</mat-option>
          </mat-select>
        </div>
        <div class="md:col-span-2">
          <label>Orden</label>
          <input class="input" type="number" formControlName="order" placeholder="Orden">
          <div *ngIf="formGroup.get('order')?.invalid && (formGroup.get('order')?.dirty || formGroup.get('order')?.touched)" class="text-red-500">
            El orden es obligatorio.
          </div>
          <div *ngIf="formGroup.get('order')?.invalid && formGroup.get('order')?.touched" class="text-red-500">
              El orden es obligatorio.
          </div>
        
        </div>
        <div class="md:col-span-3">
          <mat-checkbox class="mt-5" formControlName="required">Requerido</mat-checkbox>
        </div>
      </div>
      <!-- Orden y Requerido fields -->
      <!--
        <div class="flex items-center mr-4">
          <mat-form-field appearance="outline" class="order-field">
            <mat-label>Orden</mat-label>
            <input matInput type="number" formControlName="order" placeholder="Orden">
          </mat-form-field>
          <mat-checkbox formControlName="required">Requerido</mat-checkbox>
        </div>
      -->
      <!-- End of Orden y Requerido fields -->
      <!--
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Nombre de la etiqueta</mat-label>
          <input matInput formControlName="labelName" placeholder="Nombre de la etiqueta">
        </mat-form-field>
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Tipo de elemento</mat-label>
          <mat-select formControlName="elementType">
            <mat-option *ngFor="let element of elements" [value]="element.id">{{ element.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="isComboBoxSelected()">
          <label>Selecciona las opciones:</label>
          <div *ngFor="let option of options; let optionIndex = index" class="option-group">
            <mat-checkbox [checked]="isOptionChecked(option.id)" (change)="onOptionChange(option.id, $event.checked)">
              {{ option.name }}
            </mat-checkbox>
          </div>
        </div>
      -->
    </div>
  </mat-expansion-panel>
</div>
